import { render, staticRenderFns } from "./TranProgramModuleCreate.vue?vue&type=template&id=8b60bd80"
import script from "./TranProgramModuleCreate.vue?vue&type=script&lang=js"
export * from "./TranProgramModuleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports